import { render, staticRenderFns } from "./AdminCategoryView.vue?vue&type=template&id=7d521ce0&scoped=true&"
import script from "./AdminCategoryView.vue?vue&type=script&lang=js&"
export * from "./AdminCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategoryView.vue?vue&type=style&index=0&id=7d521ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d521ce0",
  null
  
)

export default component.exports